<script>
import { CargoDocUtil } from '@/class/cargo/model/utils/CargoDocUtil'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import { Company } from '@/class/model/mdm/Company'

export default {
  name: 'SenderAndReceiver',
  data() {
    return {
      synchronousShipperCodeAndConsigneeCodeAndNotifyCode: false,
      maxChars: 45,
      warningCount: 45,
      englishNameMaxChars: 45,
      markMaxChars: 45,
      englishNameWarningCount: 45,
      markWarningCount: 45,
      advanceTextDialog: {
        visible: false,
        title: '',
        value: '',
        showContact: false,
        extendData: {
          contact: '',
          mobile: '',
          fax: '',
          email: '',
          zipCode: '',
          city: ''
        },
        successCallback: null,
        isUppercase: false,
        formatObj: {
          warningCount: 45,
          maxChar: 45
        }
      },
      variableCss: {
        shipperLine1: '', // 发货人1
        shipperLine2: '', // 发货人2
        shipperLine3: '', // 发货人3
        shipperLine4: '', // 发货人4
        shipperLine5: '', // 发货人5
        shipperLine6: '', // 发货人6
        consigneeLine1: '', // 收货人1
        consigneeLine2: '', // 收货人2
        consigneeLine3: '', // 收货人3
        consigneeLine4: '', // 收货人4
        consigneeLine5: '', // 收货人5
        consigneeLine6: '', // 收货人6
        consigneeLine7: '', // 收货人7
        notifyLine1: '', // 通知人1
        notifyLine2: '', // 通知人2
        notifyLine3: '', // 通知人3
        notifyLine4: '', // 通知人4
        notifyLine5: '', // 通知人5
        notifyLine6: '', // 通知人6
        BLNumber: '', // 提单份数
        packing: '', // 包装
        insideQuantity: '', // 小件数
        insidePacking: '', // 小件数包装类型
        dispatchingPlace: '', // (提单发货地)发货地
        weight: '', // 提单毛重
        cubage: '', // 提单体积
        loadingPort: '', // (提单起运港)装货港
        dischargingPort: '', // (提单卸货港)中转港
        destinationPort: '', // (提单交货地)目的港
        cargoEnglishName: '', // 英文品名
        mark: '', // 唛头
        remarks: ''// 备注
      }
    }
  },
  methods: {
    initParams() {
      this.maxChars = Number(this.config.get('SEShipperConsigneNotifyMaxchars'))
      this.warningCount = Number(this.config.get('SEShipperConsigneNotifyWarningColor'))
      // 从配置中读取英文品名最大字符数
      const maxChars = Number(this.config.get('SEEnglishDescriptionOfGoodsMaxchars'))
      if (maxChars > 0) {
        this.englishNameMaxChars = maxChars
      }
      // 从配置中读取唛头最大字符数
      const maxChars2 = Number(this.config.get('SEMarkMaxChars'))
      if (maxChars2 > 0) {
        this.markMaxChars = maxChars2
      }
      // 从配置中读取海运出口MBL英文品名标红字符数
      const maxColor = Number(this.config.get('SEEnglishDescriptionOfGoodWarningColor'))
      if (maxColor > 0) {
        this.englishNameWarningCount = maxColor
      }
      // 从配置中读取海运出口MBL唛头标红字符数
      const maxColor2 = Number(this.config.get('SEMarkWarningColor'))
      if (maxColor2 > 0) {
        this.markWarningCount = maxColor2
      }
    },
    // 换行
    wrapAddr(source, from, to, maxChars) {
      CargoDocUtil.sftAddrInputWrap.call(this, source, from, to, maxChars)
    },
    // 联系人切换回调
    async senderAndReceiverChange(type, companyData, count, matchUser) {
      const form = this.form || this.job
      form[`${type}Id`] = companyData.value
      await JobUtils.synchronousShipperCodeAndConsigneeCodeAndNotifyCode(this.job, this.synchronousShipperCodeAndConsigneeCodeAndNotifyCode, type, 1)
      if (!companyData.value || parseInt(companyData.value) <= 0) {
        for (let i = 1; i <= count; i++) {
          form[`${type}Line${i}`] = ''
        }
        return
      }
      const company = new Company(companyData)
      company.manifestAddress = null
      await company.getMainfestAddress()
      this.applySenderAndReceiverManifestAddress(type, companyData, count)
      if (type === 'consignee' && matchUser) {
        JobUtils.matchUserPortConfig(this, this.job)
      }
    },
    applySenderAndReceiverManifestAddress(type, company, count) {
      const form = this.form || this.job
      const manifestAddress = company.manifestAddress
      if (manifestAddress) {
        for (let i = 1; i <= count; i++) {
          form[`${type}Line${i}`] = manifestAddress[`addressLine${i}`]
        }
      } else {
        for (let i = 1; i <= count; i++) {
          form[`${type}Line${i}`] = ''
        }
      }
    },
    // 清除
    clearSenderAndReceiver(type, count) {
      const form = this.form || this.job
      for (let i = 1; i <= count; i++) {
        form[`${type}Line${i}`] = ''
      }
    },
    // 计算颜色类
    getSenderAndReceiverColor(type, index) {
      const variableCss = this.variableCss[type + index]
      const shouldWarn = this.warningCount !== -1 && this.form[type + index].length > this.warningCount
      if ((variableCss || shouldWarn) && this.warningCount !== -1) {
        return 'red'
      }
      return ''
    },
    // 显示高级文本框
    showAdvanceTextDialog(title, value, successCallback, showContact = false, extendData = null, isUppercase = false, formatObj = null) {
      const defaultFormatObj = {
        warningCount: this.warningCount,
        maxChar: this.maxChars
      }
      this.advanceTextDialog.title = title
      this.advanceTextDialog.value = value
      this.advanceTextDialog.showContact = showContact
      if (showContact) {
        if (extendData) {
          Object.assign(this.advanceTextDialog.extendData, extendData)
        } else {
          for (const key in this.advanceTextDialog.extendData) {
            this.advanceTextDialog.extendData[key] = ''
          }
        }
      }
      this.advanceTextDialog.successCallback = successCallback
      this.advanceTextDialog.isUppercase = isUppercase
      this.advanceTextDialog.visible = true
      this.advanceTextDialog.formatObj = formatObj ? { ...defaultFormatObj, ...formatObj } : defaultFormatObj
      // 代表是从handlingInformation这个点过来的 弹框不可编辑
      if (title === this.$t('SeaExport.handlingInformation')) {
        this.advanceTextDialog.hasHandlingInformation = true
      } else {
        this.advanceTextDialog.hasHandlingInformation = false
      }
    },
    // 收发通合并，拆分，展示弹窗。。
    mergeSenderAndReceiverLine(type, count) {
      const form = this.form || this.job
      let result = ''
      for (let i = 1; i < count; ++i) {
        result += form[`${type}Line${i}`] || ''
        result += '\n'
      }
      result += (form[`${type}Line${count}`] || '')
      return result.trimEnd()
    },
    splitSenderAndReceiverLine(type, count, val, extendData) {
      const form = this.form || this.job
      let fromIndex = 0
      let i = 1
      for (; i < count; ++i) {
        const index = val.indexOf('\n', fromIndex)
        if (index === -1) {
          break
        }
        form[`${type}Line${i}`] = val.substring(fromIndex, index)
        fromIndex = index + 1
      }
      form[`${type}Line${i}`] = val.substring(fromIndex)
      for (++i; i < count + 1; ++i) {
        form[`${type}Line${i}`] = ''
      }
      if (extendData) {
        form[`${type}Contact`] = extendData.contact
        form[`${type}Mobile`] = extendData.mobile
        form[`${type}Fax`] = extendData.fax
        form[`${type}Email`] = extendData.email
        form[`${type}ZipCode`] = extendData.zipCode
        form[`${type}City`] = extendData.city
      }
    },
    showSenderAndReceiverDialog(type, count, showContact = true, isUppercase = true, formatObj) {
      const form = this.form || this.job
      const curFormatObj = formatObj || {
        warningCount: this.warningCount,
        maxChar: this.maxChars
      }
      const title = {
        shipper: this.$t('SeaExport.Shipper'),
        consignee: this.$t('SeaExport.Consignee'),
        notify: this.$t('SeaExport.NotifyParty'),
        dgconsign: 'DGCONSIGN',
        elseInvoice: 'ELSEINVOICE',
        agentParty: this.$t('SeaExport.AgentInfo')
      }
      const extendData = form ? {
        contact: form[`${type}Contact`],
        mobile: form[`${type}Mobile`],
        fax: form[`${type}Fax`],
        email: form[`${type}Email`],
        zipCode: form[`${type}ZipCode`],
        city: form[`${type}City`]
      } : null
      this.showAdvanceTextDialog(title[type], this.mergeSenderAndReceiverLine(type, count), (val, extendData) => this.splitSenderAndReceiverLine(type, count, val, extendData), showContact, extendData, isUppercase, curFormatObj)
    },
    showAlsoNotifyDialog() {
      const form = this.form || this.job
      const extendData = form ? {
        contact: form.alsoNotifyContact,
        mobile: form.alsoNotifyMobile,
        fax: form.alsoNotifyFax,
        email: form.alsoNotifyEmail,
        zipCode: form.alsoNotifyZipCode,
        city: form.alsoNotifyCity
      } : null
      this.showAdvanceTextDialog('ALSO NOTIFY', form.alsoNotify, val => { form.alsoNotify = val.toUpperCase() }, this.isCarrierUserMSC, extendData, true, {
        warningCount: this.warningCount,
        maxChar: this.maxChars
      })
    },
    finishAdvanceText() {
      const successCallback = this.advanceTextDialog.successCallback
      if (successCallback && typeof successCallback === 'function') {
        if (this.advanceTextDialog.showContact) {
          successCallback(this.advanceTextDialog.value, this.advanceTextDialog.extendData)
        } else {
          successCallback(this.advanceTextDialog.value)
        }
      }
      this.advanceTextDialog.visible = false
    }
  }
}
</script>
